export default __webpack_public_path__ + "static/media/house_dark.eb0ac50b.png";